const MobileViewToggler = ({ state, labels, callback }) => {
  const clickEvent = (status) => {
    callback(status);
  };
  return (
    <div className="mobile-nav">
      <button
        type="button"
        className="mobile-nav__button"
        onClick={(e) => {
          clickEvent(!state);
        }}
      >
        {state ? labels.listview : labels.mapview}
      </button>
    </div>
  );
};
export default MobileViewToggler;
